/* eslint-disable */
if (!localStorage.getItem('search-and-bookmark-data')) {
  localStorage.setItem('search-and-bookmark-data', JSON.stringify({
    pages: {
      key: 'title',
      data: [
                {
          title: 'Main',
                    route: 'main',
                              icon: 'HomeIcon',
                              isBookmarked: '',
                  },
                {
          title: 'Новости',
                    route: 'news',
                              icon: 'TabletIcon',
                              isBookmarked: '',
                  },
                {
          title: 'Магазин',
                    route: 'shop',
                              icon: 'ShoppingBagIcon',
                              isBookmarked: '',
                  },
                {
          title: 'Мои покупки',
                    route: 'orders',
                              icon: 'ShoppingCartIcon',
                              isBookmarked: '',
                  },
                {
          title: 'Личные приглашения',
                    route: '',
                              icon: 'CornerDownRightIcon',
                            },
                {
          title: 'Структура - Дерево',
                    route: 'tree-structure',
                              icon: 'CommandIcon',
                              isBookmarked: '',
                  },
                {
          title: ' Контракты за неделю',
                    route: 'contracts',
                              icon: 'ListIcon',
                              isBookmarked: '',
                  },
                {
          title: 'Инструменты для бизнеса',
                              icon: 'BriefcaseIcon',
                            },
                {
          title: 'Обучение',
                    route: 'courses',
                              icon: 'BookOpenIcon',
                              isBookmarked: '',
                  },
                {
          title: 'Финансы',
                    route: 'finance',
                              icon: 'CreditCardIcon',
                              isBookmarked: '',
                  },
                {
          title: 'Информация',
                              icon: 'FileTextIcon',
                            },
                {
          title: 'Профиль',
                    route: 'profile',
                              icon: 'UserIcon',
                              isBookmarked: '',
                  },
              ]
    },
  }))
}
// prettier-ignore
export default [
    {
    title: 'Main',
        route: 'main',
            icon: 'HomeIcon',
          },
    {
    title: 'Новости',
        route: 'news',
            icon: 'TabletIcon',
          },
    {
    title: 'Магазин',
        route: 'shop',
            icon: 'ShoppingBagIcon',
          },
    {
    title: 'Мои покупки',
        route: 'orders',
            icon: 'ShoppingCartIcon',
          },
    {
    title: 'Личные приглашения',
        route: '',
            icon: 'CornerDownRightIcon',
            children: [{"title":"\u0421\u043f\u0438\u0441\u043e\u043a","route":"personal-invitations","icon":"CircleIcon","isBookmarked":false},{"title":"\u041f\u0440\u0438\u0433\u043b\u0430\u0441\u0438\u0442\u044c \u043d\u043e\u0432\u0438\u0447\u043a\u0430","route":"invite","icon":"CircleIcon","isBookmarked":false}],
      },
    {
    title: 'Структура - Дерево',
        route: 'tree-structure',
            icon: 'CommandIcon',
          },
    {
    title: ' Контракты за неделю',
        route: 'contracts',
            icon: 'ListIcon',
          },
    {
    title: 'Инструменты для бизнеса',
            icon: 'BriefcaseIcon',
            children: [{"title":"\u0410\u043a\u0430\u0434\u0435\u043c\u0438\u044f","route":"academy","icon":"CircleIcon","isBookmarked":false},{"title":"\u041c\u0435\u0434\u0438\u0430 \u0431\u0430\u043d\u043a","route":"media-bank","icon":"CircleIcon","isBookmarked":false}],
      },
    {
    title: 'Обучение',
        route: 'courses',
            icon: 'BookOpenIcon',
          },
    {
    title: 'Финансы',
        route: 'finance',
            icon: 'CreditCardIcon',
          },
    {
    title: 'Информация',
            icon: 'FileTextIcon',
            children: [{"title":"\u041e \u043d\u0430\u0441","route":"about","icon":"CircleIcon","isBookmarked":false},{"title":"\u0414\u043e\u043a\u0443\u043c\u0435\u043d\u0442\u044b","route":"docs","icon":"CircleIcon","isBookmarked":false},{"title":"\u041f\u0440\u0430\u0432\u0438\u043b\u0430 \u043f\u043e\u043a\u0443\u043f\u043a\u0438 ","route":"how-to-by","icon":"CircleIcon","isBookmarked":false}],
      },
    {
    title: 'Профиль',
        route: 'profile',
            icon: 'UserIcon',
          },
  ]
